import React from "react";
import ExpandingBox from "components/ExpandingBox";
import List from "components/List";
import HistoryItem from "components/school_money/history/HistoryItem";
import StudentCreditBalance from "components/school_money/StudentCreditBalance";
import { connect } from "react-redux";
import { doesStudentUseExternalCashless } from "state/school_money/selectors";
import "./HistoryCard.css";

class HistoryCard extends React.PureComponent {

  constructor(props){
      super(props);
      this.footerMessage = false;
  }

  getPlaceholderText() {
    switch (this.props.type) {
      case "payment" : return "No Payments Made";
      case "dinner"  : return "No Dinner Bookings Made";
      case "club"    : return "No Club Bookings Made";
      case "meal"    : return "No Meal Selections Made";
      default        : return ""
    }
  }

  renderPlaceholder() {
    return (
      <div className="history-card__placeholder">
        { this.getPlaceholderText() }
      </div>
    )
  }

  // Only show this footer bar for external cashless meals.
  renderExternalCashlessMealFooterBar() {
    if( this.props.type !== "meal" ){ return; }
    if( !this.props.isExternalCashlessStudent ){ return; }
    this.footerMessage = "The Dinner Balance can take a while to update. The amount displayed may not accurately reflect the current balance.";
  }

  // Generates a footer bar if there is a footer message set.
  renderFooterBar(){
      if( this.footerMessage === false ){ return; }
      return (<div className="history-card__footer">{ this.footerMessage }</div>);
  }

  render() {
    const { historyItems, title, type, studentID, expanded } = this.props;
    const showCredit = type === "meal";

    // Set footer bar message for external cashless students meal selections.
    this.renderExternalCashlessMealFooterBar();

    return (
      <div className={`history-card history-card--${type}`}>
        <ExpandingBox cssModifier="school_money" expanded={expanded} onExpand={() => this.props.onExpand(this.props.studentID, this.props.type) } onCollapse={ () => this.props.onCollapse(null)}>
          <ExpandingBox.Header>
            <div className="history-card__header">
              <span className="history-card__title">{title}</span>
              { showCredit ? <StudentCreditBalance studentID={studentID} type="dinner_money" /> : null }
            </div>
          </ExpandingBox.Header>
          <ExpandingBox.Body>
            <div className="history-card__body">
              <List placeholder={this.renderPlaceholder()}>
                {
                  historyItems.map(historyItem => (
                    <HistoryItem
                      key={historyItem.get("id")}
                      type={type}
                      historyItem={historyItem}
                    />
                  ))
                }
              </List>
            </div>
            { this.renderFooterBar() }
          </ExpandingBox.Body>
        </ExpandingBox>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    isExternalCashlessStudent: doesStudentUseExternalCashless(state, ownProps.studentID)
  })
)(HistoryCard);



// WEBPACK FOOTER //
// ./src/components/school_money/history/HistoryCard.js